<div style="height: 85%; overflow: scroll;padding: 5px;position: relative;">
<mat-tab-group class="tabGroupPersonalDetails mt-10" [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="onTabChange()">
  <mat-tab class="tabSubPersonalDetails">
    <ng-template mat-tab-label>
   {{"AppointmentListPage.appointmentlist" | translate}}
    </ng-template>
    <mat-drawer-container class="example-container">
  <mat-drawer-content>
    <div class="mt-10">
      <span class="dot-status dot-orange">&nbsp;</span> {{ "AppointmentListPage.booked" | translate }} ({{
        statusCounts.booked
      }}) <span class="dot-status dot-green">&nbsp;</span> {{ "AppointmentListPage.arrived" | translate }} ({{
        statusCounts.arrived
      }}) <span class="dot-status dot-red">&nbsp;</span> {{ "AppointmentListPage.cancelled" | translate }} ({{
        statusCounts.cancelled
      }})
      <span class="dot-status dot-aqua">&nbsp;</span> {{ "AppointmentListPage.rescheduled" | translate }} ({{
        statusCounts.rescheduled
      }})
      <span class="dot-status dot-brown">&nbsp;</span> {{ "AppointmentListPage.noshow" | translate }} ({{
        statusCounts.noShow
      }})
      <span class="mx-10"></span>
      <span class="dot-status dot-urgent">&nbsp;</span>
      {{ "AppointmentListPage.urgent" | translate }} ({{ priorityCounts.urgent }})
      
      <span class="dot-status dot-high">&nbsp;</span>
      {{ "AppointmentListPage.high" | translate }} ({{ priorityCounts.high }})
      
      <span class="dot-status dot-normal">&nbsp;</span>
      {{ "AppointmentListPage.normal" | translate }} ({{ priorityCounts.normal }})
      
      <span class="dot-status dot-low">&nbsp;</span>
      {{ "AppointmentListPage.low" | translate }} ({{ priorityCounts.low }})
      <span class="action-button" *ngIf="isPatientCanRescheRights">
        <button
        mat-mini-fab
        class="btnBlue"
        type="button"
        data-automation-attribute="button-cancel-dialog"
        matTooltip="{{'AppointmentListPage.noshow' | translate }}"
        (click)="cancelAppt('NOSHOW')"
      >
        <mat-icon>do_not_disturb_off</mat-icon
        >
      </button>
      &nbsp;
        <button
          mat-mini-fab
          class="btnRed"
          type="button"
          data-automation-attribute="button-cancel-dialog"
          (click)="cancelAppt('cancel')"
          matTooltip="{{ 'AppointmentListPage.cancelAppointment' | translate }}"
        >
          <mat-icon>event_busy</mat-icon>
        </button>
        &nbsp;
        <button
        *ngIf="isResschedule"
          mat-mini-fab
          class="btnCyan"
          type="button"
          data-automation-attribute="button-cancel-dialog"
          matTooltip="{{ 'AppointmentListPage.rescheduleAppointment' | translate }}"
          (click)="cancelAppt('reschedule')"
        >
          <mat-icon>update</mat-icon
          >
        </button>
      </span>
    </div>
    <div class="encounter-container mt-10">
      <table
        mat-table
        [dataSource]="dataSource"
        class="mat-elevation-z8 table-encounter"
      >
      <ng-container matColumnDef="Appointno">
        <th mat-header-cell *matHeaderCellDef class="custom-header">{{"EncounterPage.Appointment" | translate}}</th>
        <td
          mat-cell
          class="col-norwap"
          *matCellDef="let element; let index = index"
        >
        <div>
          <span class="encounter-number">{{ element.appNo }}</span><br>
          <span class="encounter-token"  [ngClass]="{ 'has-background': element.servicer }">{{ element.servicer }}</span>
        </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="DepartmentName">
        <th mat-header-cell *matHeaderCellDef class="custom-header">
           {{"adt.Speciality" | translate}}
        </th>
        <td  mat-cell class="col-nowrap" *matCellDef="let element">
        <!-- <td mat-cell class="col-nowrap" *matCellDef="let element" 
        [ngClass]="{
          'vip-background': element.isVip,
          'doctor-long-name': element.doctorName.length > 50
        }"> -->

          <div>
            <strong class="Age-font">{{ element.specialty }}</strong><br>
            <div class="name-div">
            <span class="name-contain">{{ element.doctorName }}</span>
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="Gender/Age">
        <th mat-header-cell *matHeaderCellDef  class="custom-header">
          {{ "adt.genderAge" | translate }}
        </th>
        <td mat-cell *matCellDef="let element" >
        <!-- [ngClass]="{'vip-background': element.isVip}"> -->
          <div class="cell-content">
            <img src="./assets/images/{{ element.patientImage }}" alt="image" class="patient-image" />
            <div class="patient-details">
              <strong class="Age-font">{{ element.PatientAge }}</strong>
              <span>{{ element.age }}</span>
            </div>
          </div>
        </td>            
      </ng-container>

      <ng-container matColumnDef="mrn">
        <th mat-header-cell *matHeaderCellDef  class="custom-header">
          {{"EncounterPage.Patient" | translate}}
        </th>
        <td mat-cell class="col-nowrap" *matCellDef="let element" >
        <!-- [ngClass]="{
          'vip-background': element.isVip,
          'long-name': element.patientName.length > 25
        }"
        > -->
          <div>
            <div class="name-div">
            <strong class="name-container"><span *ngIf="showPatientPrefix">{{ element.displayTitle }}</span> {{ element.patientNameLangBase }}</strong>
             <div  *ngIf="element.isVip">
              <img src="./assets/images/vip-icon.png" height="20px"/>
             </div>
            <div  *ngIf="element.isNoteVisible">
              <img src="./assets/images/chat-alert.png" [matTooltip]="element.isNoteVisible"/>
             </div>
            <br>
            </div>
            <span class="doctor-name">{{ element.mrnNumber }}</span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef class="custom-header">
          {{ "EncounterListPage.status" | translate }}
        </th>
    <td mat-cell *matCellDef="let element">
      <span
        class="status-box"  
        [ngStyle]=" getStatusColor(element.status)"
      >
        {{ element.status }}
      </span>
    </td>
      </ng-container>

      <ng-container matColumnDef="Appointmentdetails">
        <th mat-header-cell *matHeaderCellDef class="custom-header">
          {{"EncounterPage.appointmentDetails" | translate}}
        </th>
        <td mat-cell class="col-norwap" *matCellDef="let element">
          <strong  class="Age-font">{{ langaugeValue=='th'?element.appointmentDate: (element.appointmentDate | date : "dd/MM/yyyy hh:mm aa")  }}</strong><br>
          <div style="display: flex;">         
          <div style="width: 30%;"><span>({{ element.type  }})</span></div>
          <div style="width: 30%;"><span class="encounter-token"  [ngClass]="{ 'has-background': element.appointmentType }">{{ element.appointmentType}}</span>
          </div></div>
        </td>
      </ng-container>
     <ng-container matColumnDef="priority">
        <th mat-header-cell *matHeaderCellDef class="custom-header">{{"AppointmentListPage.priority" | translate}}</th>
        <td mat-cell class="col-norwap center" *matCellDef="let element">
          <div class="priority-container">
            <span class="dot-status-column" [ngClass]="getPriorityClass(element.appoinmentPriorityCode)">
            </span>
            <span class="priority-text">
              {{ element.priority }}
            </span>
          </div>
        </td>
        </ng-container>
      <ng-container matColumnDef="package">
        <th mat-header-cell *matHeaderCellDef class="custom-header">{{"billing.package" | translate}}</th>
        <td mat-cell class="col-norwap center" *matCellDef="let element">
          <span style="font-weight: 300;font-size: 14px;"> {{ element.packageValue}}</span>
         
        </td>
      </ng-container>

      <ng-container matColumnDef="calledStatus">
        <th mat-header-cell *matHeaderCellDef class="custom-header">{{"AppointmentListPage.calledStatus" | translate}}</th>
        <td mat-cell class="col-norwap center" *matCellDef="let element">
          <span style="font-weight: 300;font-size: 14px;"> {{ element.calledStatus}}</span>
        </td>
      </ng-container>
       <ng-container matColumnDef="needTranslator" *ngIf="isNeedTranslator">
          <th mat-header-cell *matHeaderCellDef class="custom-header">
            {{"EncounterPage.needTranslator" | translate}}
          </th>
        
          <td mat-cell *matCellDef="let element" class="text-center">
            <div class="translator-icons" *ngIf="element.needTranslator">
              <mat-icon class="done-icon">
                done
              </mat-icon>
              <mat-icon *ngIf="element.translatorLanguage" class="info-icon" [matTooltip]="element.translatorLanguage">
                info
              </mat-icon>
            </div>
          </td>
        </ng-container>
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef class="custom-header">
          {{"adt.action" | translate}}
        </th>
        <td mat-cell class="col-norwap" *matCellDef="let element">
          <div class="image-container">
            <!-- Cancel Appointment Button with Image -->
             
          <mat-icon [ngStyle]="{'color': element.previousRemarks.length>0 ? 'green' : ''}" 
            matTooltip="{{ 'AppointmentListPage.remarks' | translate }}"
             (click)="addRemarks(element)"> mode_comment</mat-icon>
      
            <!-- Reschedule Appointment Button with Image -->
            <!-- <button -->
              <mat-icon
              (click)="openReasonComments(element)"
              class="grey"
              matTooltip="{{'AppointmentListPage.info' | translate }}"
            >
            info
            </mat-icon>
            <!-- </button> -->
      
            <!-- Check-in Button with Image -->
            <mat-icon
            *ngIf="!element.isAppoinmentConfirmed && element.checkIn && (element.selected == 'booked'|| element.status == 'Rescheduled')"            
              matTooltip="{{ 'AppointmentListPage.checkin' | translate }}"
              class="green"
              (click)="Workflowmethod(element)"
              data-automation-attribute="icon-check-in"
            >
              input
            </mat-icon>
            <mat-icon matTooltip="{{'AppointmentListPage.appointmentSlip' | translate}}"  (click)="printReport(element.id)">print</mat-icon>
            <mat-icon matTooltip="{{'AppointmentListPage.appointmentSlip' | translate}}"  (click)="openContactDetails(element.app)"> contact_phone</mat-icon>
              <img
                src="./assets/images/specialRequirement.png"
                [matTooltip]="element.specialRequirementTooltip"
                matTooltipClass="multiline-tooltip"
                *ngIf="element.specialRequirementTooltip"
                width="24"
                height="24"
              />
              <mat-icon *ngIf="element.type === 'REG'" matTooltip="Patient History" (click)="openHistory(element)">
                history
              </mat-icon>
          </div>
        </td>
      </ng-container>

        <ng-container matColumnDef="check">
          <th mat-header-cell *matHeaderCellDef class="custom-header">
            <mat-checkbox
              class="check-white"
              (change)="selectAll($event)"
            ></mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let element">
            <mat-checkbox
              [(ngModel)]="element.apptSelection"
              (change)="selectCheckBox($event,element)"
              *ngIf="element.selected == 'booked' || element.status == 'Rescheduled'"
            ></mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="Print">
          <th mat-header-cell *matHeaderCellDef>{{ "AppointmentListPage.print" | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <mat-icon matTooltip="{{'AppointmentListPage.appointmentSlip' | translate}}" (click)="printReport(element.id)" yPosition="below">print</mat-icon>
          </td>
       
        </ng-container>

        <ng-container matColumnDef="Appno">
          <th mat-header-cell *matHeaderCellDef>{{ "AppointmentListPage.appointmentNo" | translate }}</th>
          <td
            mat-cell
            class="col-norwap"
            *matCellDef="let element; let index = index"
          >
            <span
              class="dot-status dot-orange"
              *ngIf="element.status == 'booked'"
            >
              &nbsp;
            </span>
            <span
              class="dot-status dot-green"
              *ngIf="element.status == 'arrived'"
              >&nbsp;
            </span>
            <span
              class="dot-status dot-pink"
              *ngIf="element.status == 'reschedule'"
              >&nbsp;</span
            >
            <span
              class="dot-status dot-red"
              *ngIf="element.status == 'cancelled'"
              >&nbsp;</span
            >
            <span
              class="dot-status dot-aqua"
              *ngIf="element.status == 'rescheduled'"
              >&nbsp;</span
            >{{ element.appNo }}
          </td>
        </ng-container>

        <ng-container matColumnDef="Doctor">
          <th mat-header-cell *matHeaderCellDef>Doctor</th>
          <td mat-cell class="column-content" *matCellDef="let element"
              [ngClass]="{
                'doctor-long-name': element.doctorName.length > 50
              }">
            <div class="name-div">
              <span class="name-container">{{ element.doctorName| NameFormat }}</span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="PatientDeatils">
          <th mat-header-cell *matHeaderCellDef>{{ "adt.genderAge" | translate }}</th>
          <td mat-cell class="col-norwap" *matCellDef="let element">
            {{ element.PatientGender }}
          </td>
        </ng-container>
        <ng-container matColumnDef="Speciality">
          <th mat-header-cell *matHeaderCellDef>{{ "AppointmentPage.specialty" | translate }}</th>
          <td mat-cell class="col-norwap" *matCellDef="let element">
            {{ element.specialty }}
          </td>
        </ng-container>
        <ng-container matColumnDef="MRN">
          <th mat-header-cell *matHeaderCellDef>{{ "AppointmentListPage.mrntrn" | translate }}</th>
          <td mat-cell class="col-norwap" *matCellDef="let element">
            {{ element.mrnNumber }}
          </td>
        </ng-container>
        <ng-container matColumnDef="Patient">
          <th mat-header-cell *matHeaderCellDef>{{ "AppointmentListPage.patient" | translate }}</th>
          <td mat-cell class="column-content" *matCellDef="let element"
              [ngClass]="{
                'long-name': element.patientName.length > 50
              }">
            <div style="display: flex;">
              <div>
                <img [src]="element.gender === 'MALE' ? './assets/images/male_profile.png' : './assets/images/female_profile.png'"
                     alt="image" style="height: 20px; margin-right: 5px;" />
              </div>
              <div class="name-div">
                <span class="name-container">{{ element.patientName | NameFormat }}</span>
              </div>
              <div>
                <img class="user-img"
                     [src]="element.isVip ? './assets/images/email-icons/vip-icon.png' : null"
                     *ngIf="element.isVip"
                     style="height: 20px; margin-bottom: 5px; float: right;" />
              </div>
            </div>
          </td>
        </ng-container>
       

        <ng-container matColumnDef="bookingType">
          <th mat-header-cell *matHeaderCellDef>{{ "AppointmentListPage.bookingType" | translate }}</th>
          <td
            mat-cell
            class="col-norwap"
            *matCellDef="let element"
          >
            {{ element.bookingType }}
          </td>
        </ng-container>

        <ng-container matColumnDef="PatientType">
          <th mat-header-cell *matHeaderCellDef>{{ "AppointmentListPage.patientType" | translate }}</th>
          <td mat-cell class="col-norwap" *matCellDef="let element">
            {{ element.patientType }}
          </td>
        </ng-container>
        <ng-container matColumnDef="SpecialReq">
          <th mat-header-cell *matHeaderCellDef>Special Requirement</th>
          <td mat-cell class="col-norwap center" *matCellDef="let element">
            <mat-icon
              *ngIf="element.specialReq"
              class="grey"
              matTooltip="{{ element.specialReq ? element.specialReq : '' }}"
            >
            mode_comment
            </mat-icon>
           
          </td>
        </ng-container>
        <ng-container matColumnDef="Package">
          <th mat-header-cell *matHeaderCellDef>Package</th>
          <td mat-cell class="col-norwap center" *matCellDef="let element">
            <mat-icon
              *ngIf="element.package"
              class="grey"
              matTooltip="{{ element.package ? element.package : '' }}"
            >
            mode_comment
            </mat-icon>
           
          </td>
        </ng-container>
      
        <ng-container matColumnDef="VisitType">
          <th mat-header-cell *matHeaderCellDef>{{ "AppointmentListPage.visit" | translate }}</th>
          <td mat-cell class="col-norwap" *matCellDef="let element">
            {{ element.VisitType }}
          </td>
        </ng-container>
              <ng-container matColumnDef="AppointmentDate">
          <th mat-header-cell *matHeaderCellDef>{{ "AppointmentListPage.appointmentOn" | translate }}</th>
          <td mat-cell class="col-norwap" *matCellDef="let element">
            {{ element.appointmentDate | date: "dd/MM/yyyy hh:mm aa" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="TokenNo">
          <th mat-header-cell *matHeaderCellDef>{{ "AppointmentListPage.tokenNo" | translate }}</th>
          <td mat-cell class="col-norwap" *matCellDef="let element">
            {{ element.token }}
          </td>
        </ng-container>
        <ng-container matColumnDef="CheckIn">
          <th mat-header-cell *matHeaderCellDef>{{ "AppointmentListPage.checkin" | translate }}</th>
          <td mat-cell class="col-norwap" *matCellDef="let element">
            <mat-icon
            *ngIf="!element.isAppoinmentConfirmed && element.checkIn && (element.selected == 'booked'|| element.status == 'Rescheduled')"            
              matTooltip="{{ 'AppointmentListPage.checkin' | translate }}"
              class="green"
              (click)="Workflowmethod(element)"
              data-automation-attribute="icon-check-in"
            >
              input
            </mat-icon>
            {{ element.checkInTime | date: "dd/MM/yyyy hh:mm aa" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="response">
         <th mat-header-cell *matHeaderCellDef class="custom-header">{{"AppointmentListPage.response" | translate}}</th>
          <td mat-cell class="col-norwap center" *matCellDef="let element">
           {{ element.patientResponse}}
         </td>
        </ng-container>
        
        <ng-container matColumnDef="Remarks">
          <th mat-header-cell *matHeaderCellDef>{{ "AppointmentListPage.remarks" | translate }}</th>
          <td mat-cell class="col-norwap center" *matCellDef="let element">
          
          <mat-icon [ngStyle]="{'color': element.previousRemarks.length>0 ? 'green' : ''}" 
          matTooltip="{{ 'AppointmentListPage.remarks' | translate }}"
           (click)="addRemarks(element)">info</mat-icon>
   
        </ng-container>

        <ng-container matColumnDef="Status">
          <th mat-header-cell *matHeaderCellDef >{{ "AppointmentListPage.status" | translate }}</th>
          <td mat-cell *matCellDef="let element" >
         <b class="backgroundColor"  [ngStyle]=" getStatusColor(element.status) " >{{ element.status }}</b> 
          </td>
        </ng-container>

        <ng-container matColumnDef="Reason">
          <th mat-header-cell *matHeaderCellDef>{{ "payerInfo.reason" | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <div class="status-div"></div>
            <div class="center">
              <mat-icon
                (click)="openReasonComments(element)"
                matTooltip="{{ 'payerInfo.reason' | translate }}"
                >info</mat-icon
              >
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; let i = index; columns: displayedColumns"
          (click)="getIndex(i, row)"
          class="mat-row {{ selectedRow == i ? 'row-hightlighted' : '' }}"
        ></tr>
      </table>

      <div class="center" *ngIf="dataSource.data.length == 0">
        {{ "AppointmentListPage.noappointment" | translate }}
      </div>
    </div>
    <!-- <div class="refresh-block">
      <mat-grid-list cols="10" rowHeight="70px">
        <mat-grid-tile [colspan]="1">
          <mat-icon
            class="cyanFont green text-align"
            (click)="refreshSearch()"
            matTooltip="{{ 'adt.refresh' | translate }}"
            data-automation-attribute="icon-cancel"
            >refresh</mat-icon
          >
        </mat-grid-tile>
        <mat-grid-tile [colspan]="3"></mat-grid-tile>
        <mat-grid-tile [colspan]="3"></mat-grid-tile>
        <mat-grid-tile [colspan]="3">
          <mat-paginator
            [length]="totalDataLength"
            [pageSize]="pageSize"
            (page)="getNext($event)"
            #paginator
            [pageSizeOptions]="paginatorOptions"
          >
          </mat-paginator>
        </mat-grid-tile>
      </mat-grid-list>
    </div> -->
  </mat-drawer-content>
</mat-drawer-container>
</mat-tab>
<mat-tab class="tabSubPersonalDetails">
  <ng-template mat-tab-label>
 {{"AppointmentListPage.waitinglist" | translate}}
  </ng-template>
  <!-- <mat-grid-list cols="10" rowHeight="30px" >
    <mat-grid-tile [colspan]="9"></mat-grid-tile>
    <mat-grid-tile [colspan]="1">
  <button
        mat-mini-fab
        class="btnCyan"
        style="float: right;"
        type="submit"
        data-automation-attribute="button-cancel-dialog"
        matTooltip="Add"
        (click)="addWaitingList()"
      >
        <mat-icon
          >add</mat-icon
        >
      </button></mat-grid-tile>
    </mat-grid-list> -->
  <div class="table-container" style="overflow: auto; height: 70vh;">
    <table mat-table [dataSource]="waitingListDataSource" class="mat-elevation-z8" matSort>
      <!-- Appointment Column -->
      <ng-container matColumnDef="appointment">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{"AppointmentListPage.Waitingno" | translate}} </th>
        
        <td mat-cell *matCellDef="let element">  
          <div>
            <span class="encounter-number">{{element.identifier[0].value}}</span><br>
            <span class="encounter-token"  [ngClass]="{ 'has-background': element.serviceCategoryDisplay }">{{ element.serviceCategoryDisplay }}</span>
          </div>
           </td>
      </ng-container>
  
      <!-- Patient Column -->
      <ng-container matColumnDef="patient">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>   {{"EncounterPage.Patient" | translate}} </th>
        <td mat-cell *matCellDef="let element"> 
          <strong class="Age-font">{{element.nameDisplay}}</strong> <br>
          {{element.mrn}}
        </td>
      </ng-container>
  
      <!-- Gender/Age Column -->
      <ng-container matColumnDef="gender/age">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "adt.genderAge" | translate }}</th>
        <td mat-cell *matCellDef="let element">
          <div class="cell-content">
            <img src="./assets/images/{{ element.genderImage }}" alt="image" class="patient-image" />
            <div class="patient-details">
              <strong class="Age-font">{{ element.ageDisplay }}</strong>
              <span>{{ element.dobDisplay | date: 'dd/MM/yyyy' }} / {{ element.genderDisplay }}</span>
            </div>
          </div>
        </td>
      </ng-container>
      <!-- Speciality/Doctor Column -->
      <ng-container matColumnDef="speciality/doctor">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{"adt.Speciality" | translate}} </th>
        <td mat-cell *matCellDef="let element">
          <strong class="Age-font">{{ element.specialityDisplay }}</strong><br>
          <span class="name-contain">{{ element.doctorDisplay }}</span>
         </td>
      </ng-container>
  
      <!-- Date Preference Column -->
      <ng-container matColumnDef="datePreferance">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{"AppointmentListPage.datePreference"| translate}}</th>
        <td mat-cell *matCellDef="let element"><strong class="Age-font">{{ element.datePreferanceDisplay}} </strong> </td>
      </ng-container>
  
      <!-- Contact Number Column -->
      <ng-container matColumnDef="contactNo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{"SearchHeader.phone" | translate}} </th>
        <td mat-cell *matCellDef="let element"> <strong class="Age-font">
          {{element.countryCodeDisplay}} &nbsp; {{ element.contactDisplay}}</strong> </td>
      </ng-container>
  
      <!-- Request On Column -->
      <ng-container matColumnDef="requestOn">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{"adt.requestOn" | translate}} </th>
        <td mat-cell *matCellDef="let element"> 
          <strong class="Age-font">{{ element.requestOnDesplay ? (element.requestOnDesplay * 1000 | date: 'dd/MM/yyyy hh:mm a') : ''}}</strong>
        <br><span class="name-contain">({{element.timeDesplay}})</span>
      </td>
      </ng-container>
          <!-- Status On Column -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{"adt.status" | translate}} </th>
            <td mat-cell *matCellDef="let element"> 
              <span
              class="status-box"  
              [ngStyle]=" getStatusColor(element.businessStatus)"
            >{{ element.businessStatus }}</span> 
          </td>
          </ng-container>
  
      <!-- Action Column -->
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef> {{"MergeListPage.action" | translate}} </th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button color="green" matTooltip="{{'AppointmentListPage.confirm' | translate }}" (click)="confirmWaitingPatient(element)">
            <mat-icon>done</mat-icon>
          </button>
          <button mat-icon-button color="black" matTooltip="{{'AppointmentListPage.edit' | translate }}" (click)="editWaitingList(element)">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button color="warn" matTooltip="{{'AppointmentListPage.cancelPatient' | translate}}" (click)="cancelWaitingPatient(element)" >
            <mat-icon>cancel</mat-icon>
          </button>
        </td>
      </ng-container>
  
      <!-- Table Header and Row -->
      <tr mat-header-row *matHeaderRowDef="waitingListDisplayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: waitingListDisplayedColumns;"></tr>
    </table>
  </div>
  

  </mat-tab>
</mat-tab-group>  
</div>
  <button
  *ngIf="selectedTabIndex==1"
        mat-mini-fab
        class="btnCyan add-btn"
        style="float: right;"
        type="submit"
        data-automation-attribute="button-cancel-dialog"
        matTooltip="{{'AppointmentListPage.add' | translate}}"
        (click)="addWaitingList()"
      >
        <mat-icon
          >add</mat-icon
        >
      </button>
<div class="footer-container">
  <app-footer
  [showFooter]="true"
  [totalDataLength]="totalDataLength"
  [pageSize]="pageSize"
  [pageIndex]="pageIndex"
  [paginatorOptions]="paginatorOptions"
  (pageChange)="getNext($event)"
  (refresh)="refreshSearch()">
  </app-footer>
  </div>